
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../BaseUrl";
import { toastError, toastSuccess } from "../../AlertMessage/AlertMessage";

// --------------------plantation Techniques Post API---------------------

export const plantationTechniquesPostAPI = createAsyncThunk("plantationTechniquesPost", async ({ data }) => {
    const {
        FinancialYearID,
        MonthsID,
        M_BeneficiaryDetailsID,
        T_BeneficiaryPlantationDetailsID,
        RawData,
        M_TableUserMasterID,
        token,
        handleDataIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("FinancialYearID", FinancialYearID);
    formdata.append("MonthsID", MonthsID);
    formdata.append("M_BeneficiaryDetailsID", M_BeneficiaryDetailsID);
    formdata.append("T_BeneficiaryPlantationDetailsID", T_BeneficiaryPlantationDetailsID);
    formdata.append("RawData", RawData);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);

    const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Transaction/Post_APK_T_BeneficiaryPlantationDetails_PlantationTechniques_Insert`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.status) {
                handleDataIsPost()
                toastSuccess(result.message)
            } else {
                toastError(result.message)
            }
            return result
        })
})

const plantationTechniquesPostSlice = createSlice({
    name: "plantationTechniquesPost",
    initialState: {
        isPostLoading: false,
        PostData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(plantationTechniquesPostAPI.pending, (state, action) => {
            state.isPostLoading = true;
        });
        builder.addCase(plantationTechniquesPostAPI.fulfilled, (state, action) => {
            state.isPostLoading = false;
            state.PostData = action.payload;
        });
        builder.addCase(plantationTechniquesPostAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading = false;
            state.isError = true;
            state.PostData = null;

        });
    },
})

export const plantationTechniquesPostReducer = plantationTechniquesPostSlice.reducer

// --------------------Part-4 Post API---------------------

export const PlantationDetailsPartFourPatchAPI = createAsyncThunk("PlantationDetailsPartFourPatch", async ({ data }) => {
    const {
        FinancialYearID,
        MonthsID,
        M_BeneficiaryDetailsID,
        T_BeneficiaryPlantationDetailsID,
        PlantationTechniques_M_IndicatorID,
        Frequncy_M_IndicatorID,
        ThreatCattle_M_IndicatorID,
        ThreatWildAnimals_M_IndicatorID,
        Fence_Protect_Plantations_M_IndicatorID,
        Apply_Pesticides_M_IndicatorID,
        M_TableUserMasterID,
        token,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("FinancialYearID", FinancialYearID);
    formdata.append("MonthsID", MonthsID);
    formdata.append("T_BeneficiaryPlantationDetailsID", T_BeneficiaryPlantationDetailsID);
    formdata.append("M_BeneficiaryDetailsID", M_BeneficiaryDetailsID);
    formdata.append("PlantationTechniques_M_IndicatorID", PlantationTechniques_M_IndicatorID);
    formdata.append("Frequncy_M_IndicatorID", Frequncy_M_IndicatorID);
    formdata.append("ThreatCattle_M_IndicatorID", ThreatCattle_M_IndicatorID);
    formdata.append("ThreatWildAnimals_M_IndicatorID", ThreatWildAnimals_M_IndicatorID);
    formdata.append("Fence_Protect_Plantations_M_IndicatorID", Fence_Protect_Plantations_M_IndicatorID);
    formdata.append("Apply_Pesticides_M_IndicatorID", Apply_Pesticides_M_IndicatorID);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);

    const requestOptions = {
        method: "PATCH",
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Transaction/APK_T_BeneficiaryPlantationDetails_4_Update`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.status) {
                handleIsPost()
                toastSuccess(result.message)
            } else {
                toastError(result.message)
            }
            return result
        })
})

const PlantationDetailsPartFourPatchSlice = createSlice({
    name: "PlantationDetailsPartFourPatch",
    initialState: {
        isPostLoading: false,
        PostData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PlantationDetailsPartFourPatchAPI.pending, (state, action) => {
            state.isPostLoading = true;
        });
        builder.addCase(PlantationDetailsPartFourPatchAPI.fulfilled, (state, action) => {
            state.isPostLoading = false;
            state.PostData = action.payload;
        });
        builder.addCase(PlantationDetailsPartFourPatchAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading = false;
            state.isError = true;
            state.PostData = null;

        });
    },
})


export const PlantationDetailsPartFourPatchReducer = PlantationDetailsPartFourPatchSlice.reducer

// ------------------------------plantation Techniques Delete API -------------------------------

export const PlantationTechniquesDeleteAPI = createAsyncThunk("PlantationTechniquesDelete", async ({ data }) => {
    const {
        T_BeneficiaryPlantationDetails_PlantationTechniquesID,
        M_TableUserMasterID,
        token,
        handleDataIsPost,
        handleShowDelete
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("T_BeneficiaryPlantationDetails_PlantationTechniquesID", T_BeneficiaryPlantationDetails_PlantationTechniquesID);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);

    const requestOptions = {
        method: "DELETE",
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Transaction/Web_T_BeneficiaryPlantationDetails_PlantationTechniques_Delete`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if ((result.code >= 200 && result.code <= 300) && result.status) {
                // console.log(result.message)
                toastSuccess(result.message)
                handleDataIsPost()
                handleShowDelete()
            } else {
                toastError(result.message)
            }
            return result
        })
})

const PlantationTechniquesDeleteSlice = createSlice({
    name: "PlantationTechniquesDelete",
    initialState: {
        isDeleteLoading: false,
        DeleteData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PlantationTechniquesDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(PlantationTechniquesDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.DeleteData = action.payload;
        });
        builder.addCase(PlantationTechniquesDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.DeleteData = null;

        });
    },
})

export const PlantationTechniquesDeleteReducer = PlantationTechniquesDeleteSlice.reducer

// --------------------Threat from wild animals Post API---------------------

export const ThreatWildAnimalsPostAPI = createAsyncThunk("ThreatWildAnimalsPost", async ({ data }) => {
    const {

        T_BeneficiaryPlantationDetailsID,
        ThreatWildAnimals_Name,
        M_TableUserMasterID,
        token,
        // handleIsAnimalData
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("T_BeneficiaryPlantationDetailsID", T_BeneficiaryPlantationDetailsID);
    formdata.append("ThreatWildAnimals_Name", ThreatWildAnimals_Name);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);

    const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Transaction/Post_APK_T_BeneficiaryPlantationDetails_ThreatWildAnimals_Insert`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.status) {
                // handleIsAnimalData()
                // toastSuccess(result.message)
                toastSuccess("Data Update Successfully")

            } else {
                toastError(result.message)
            }
            return result
        })
})

const ThreatWildAnimalsPostSlice = createSlice({
    name: "ThreatWildAnimalsPost",
    initialState: {
        isPostLoading1: false,
        PostData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ThreatWildAnimalsPostAPI.pending, (state, action) => {
            state.isPostLoading1 = true;
        });
        builder.addCase(ThreatWildAnimalsPostAPI.fulfilled, (state, action) => {
            state.isPostLoading1 = false;
            state.PostData = action.payload;
        });
        builder.addCase(ThreatWildAnimalsPostAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading1 = false;
            state.isError = true;
            state.PostData = null;

        });
    },
})

export const ThreatWildAnimalsPostReducer = ThreatWildAnimalsPostSlice.reducer

// ------------------------------plantation Techniques Delete API -------------------------------

export const ThreatWildAnimalsDeleteAPI = createAsyncThunk("ThreatWildAnimalsDelete", async ({ data }) => {
    const {
        T_BeneficiaryPlantationDetailsID,
        M_TableUserMasterID,
        Flag,
        token,
        handleIsAnimalData,
        handleShowDelete
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("T_BeneficiaryPlantationDetailsID", T_BeneficiaryPlantationDetailsID);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);
    formdata.append("Flag", Flag);

    const requestOptions = {
        method: "DELETE",
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Transaction/Web_T_BeneficiaryPlantationDetails_4_Delete`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if ((result.code >= 200 && result.code <= 300) && result.status) {
                // console.log(result.message)
                toastSuccess(result.message)
                handleIsAnimalData()
                handleShowDelete()
            } else {
                toastError(result.message)
            }
            return result
        })
})

const ThreatWildAnimalsDeleteSlice = createSlice({
    name: "ThreatWildAnimalsDelete",
    initialState: {
        isDeleteLoading: false,
        DeleteData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ThreatWildAnimalsDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(ThreatWildAnimalsDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.DeleteData = action.payload;
        });
        builder.addCase(ThreatWildAnimalsDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.DeleteData = null;

        });
    },
})

export const ThreatWildAnimalsDeleteReducer = ThreatWildAnimalsDeleteSlice.reducer

// --------------------Threat from wild animals Post API---------------------

export const ProtectFencingPostAPI = createAsyncThunk("ProtectFencingPost", async ({ data }) => {
    const {

        T_BeneficiaryPlantationDetailsID,
        Kind_Of_Fence_M_IndicatorID,
        Cost_Of_Fence,
        M_TableUserMasterID,
        token,
        // handleIsFenchData
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("T_BeneficiaryPlantationDetailsID", T_BeneficiaryPlantationDetailsID);
    formdata.append("Kind_Of_Fence_M_IndicatorID", Kind_Of_Fence_M_IndicatorID);
    formdata.append("Cost_Of_Fence", Cost_Of_Fence);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);

    const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Transaction/Post_APK_T_BeneficiaryPlantationDetails_ProtectFencing_Insert`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.status) {
                // handleIsFenchData()
                toastSuccess("Data Update Successfully")
            } else {
                toastError(result.message)
            }
            return result
        })
})

const ProtectFencingPostSlice = createSlice({
    name: "ProtectFencingPost",
    initialState: {
        isPostLoading2: false,
        PostData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ProtectFencingPostAPI.pending, (state, action) => {
            state.isPostLoading2 = true;
        });
        builder.addCase(ProtectFencingPostAPI.fulfilled, (state, action) => {
            state.isPostLoading2 = false;
            state.PostData = action.payload;
        });
        builder.addCase(ProtectFencingPostAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading2 = false;
            state.isError = true;
            state.PostData = null;

        });
    },
})

export const ProtectFencingPostReducer = ProtectFencingPostSlice.reducer

// --------------------Pesticides Post API---------------------

export const PesticidesPostAPI = createAsyncThunk("PesticidesPost", async ({ data }) => {
    const {

        T_BeneficiaryPlantationDetailsID,
        WhichPesticide,
        Frequency_For_Pesticide_M_IndicatorID,
        M_TableUserMasterID,
        token,
        // handleIsFenchData
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("T_BeneficiaryPlantationDetailsID", T_BeneficiaryPlantationDetailsID);
    formdata.append("WhichPesticide", WhichPesticide);
    formdata.append("Frequency_For_Pesticide_M_IndicatorID", Frequency_For_Pesticide_M_IndicatorID);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);

    const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Transaction/Post_APK_T_BeneficiaryPlantationDetails_PesticideUsed_Insert`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.status) {
                // handleIsFenchData()
                toastSuccess("Data Update Successfully")
            } else {
                toastError(result.message)
            }
            return result
        })
})

const PesticidesPostSlice = createSlice({
    name: "PesticidesPost",
    initialState: {
        isPostLoading3: false,
        PostData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PesticidesPostAPI.pending, (state, action) => {
            state.isPostLoading3 = true;
        });
        builder.addCase(PesticidesPostAPI.fulfilled, (state, action) => {
            state.isPostLoading3 = false;
            state.PostData = action.payload;
        });
        builder.addCase(PesticidesPostAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading3 = false;
            state.isError = true;
            state.PostData = null;

        });
    },
})

export const PesticidesPostReducer = PesticidesPostSlice.reducer





